const errorConstants = {
  searchError: 'E00001'
};

export default errorConstants;
